(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/seo-articles/assets/javascripts/seo-articles.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/seo-articles/assets/javascripts/seo-articles.js');
"use strict";


const {
  useContext,
  useEffect
} = React;
const {
  NavContext
} = svs.oddset_kambi.components.nav_context;
const {
  cmsArticles
} = svs.oddset_kambi.data;
const {
  getSeoArticles
} = svs.oddset_kambi.components.seo_articles.getSeoArticles;
const SeoArticles = () => {
  const {
    windowLocationPathname
  } = useContext(NavContext);
  const articles = getSeoArticles(cmsArticles, windowLocationPathname);
  useEffect(() => {
    const serverArticlesSection = document.querySelector('#seo-articles-rendered-from-server');
    if (serverArticlesSection) {
      serverArticlesSection.remove();
    }
  }, []);
  return React.createElement("section", {
    className: "seo-widget-articles f-content",
    id: "seo-articles-rendered-from-client"
  }, articles.map(_ref => {
    let {
      article
    } = _ref;
    return React.createElement("article", {
      dangerouslySetInnerHTML: {
        __html: article.body
      },
      key: JSON.stringify(article)
    });
  }));
};
setGlobal('svs.oddset_kambi.components.seo_articles.SeoArticles', SeoArticles);

 })(window);